export default "__VITE_ASSET__CC$noKlJ__"